// Owner: P1 piece 9 "Organisation relations graph" (docs/FILE-OWNERSHIP.md).
// The feature's entry file (docs/CONTRACTS.md section 16): the explorer at /explorer, one lazy chunk (sigma and graphology
// load only here). The path carries an organisation number, a depth and a view, never free text.
import { createRoute, lazyRouteComponent } from '@tanstack/react-router'
import { Orbit } from 'lucide-react'
import type { Feature } from '../feature.ts'
import { parseSearch } from './search.ts'

export const feature: Feature = {
  app: (parent) => [
    createRoute({
      getParentRoute: () => parent,
      path: '/explorer',
      validateSearch: (search: Record<string, unknown>) => parseSearch(search),
      component: lazyRouteComponent(() => import('./ExplorerScreen.tsx')),
    }),
  ],
  nav: [{ to: '/explorer', label: 'nav.explorer', icon: Orbit, group: 'network', key: 'x' }],
}
